<template>
    <v-row>
        <v-col v-if="showNavigation" cols="12" class="px-8 pa-md-0 pb-md-2 " :class="{'position-absolute': $vuetify.display.mdAndUp}" style="z-index: 100; width: calc(100% - 48px)">
            <div class="d-flex justify-space-between ga-4">
                <v-btn
                    :loading="loadingProduct"
                    color="cis-accent-color"
                    class="bg-white"
                    :disabled="!showLeft"
                    :icon="mdiChevronLeft"
                    variant="outlined"
                    size="32"
                    @click="paginate"
                >
                </v-btn>
                <v-btn
                    :loading="loadingProduct"
                    color="cis-accent-color"
                    :disabled="!showRight"
                    class="bg-white"
                    :icon="mdiChevronRight"
                    size="32"
                    variant="outlined"
                    @click="paginate(false)"
                >
                </v-btn>
                <v-spacer></v-spacer>

                <v-btn
                    :icon="mdiClose"
                    variant="plain"
                    size="x-small"
                    class="text-body-1"
                    color="grey-lighten-1"
                    @click="emit('close')"
                >
                </v-btn>
            </div>
        </v-col>
        <v-col
            v-if="$vuetify.display.lgAndUp" cols="12" lg="5">
            <product-main-image
                :class="{'mt-4': showNavigation}"
                :product="product"
                :is-modal="isModal"
                :other-images-count="otherImagesCount"
                @open-gallery="gallery = true"
                @swiper-main="swiperMain = $event"
                @swiper-thumbs="swiperThumbs = $event"
            ></product-main-image>
        </v-col>
        <v-col cols="12" lg="7">
            <v-sheet>
                <motonet-header>
                    <h1 class="text-h4 text-md-h3 font-weight-bold">{{ product.name }}</h1>
                </motonet-header>
                <div class="px-3 pr-lg-0 pl-lg-10 text-grey">
                    <div class="d-flex align-center my-4 ga-6 text-body-2">
                        <div>
                            {{ $t('eshop::product-quick-detail.stock_number') }}: {{ product.stock_number }}
                        </div>
                        <div v-if="product.manufacturer" class="d-flex align-center">
                            <span>{{ $t('eshop::product-quick-detail.creator') }}:&nbsp;</span>
                            <Link :href="product.manufacturer.url" class="text-orange text-decoration-underline">
                                {{ product.manufacturer.name }}
                            </Link>
                        </div>
                    </div>
                    <client-only>
                        <product-main-image
                            v-if="$vuetify.display.mdAndDown"
                            :product="product"
                            :is-modal="isModal"
                            :other-images-count="otherImagesCount"
                            class="mb-4"
                            @open-gallery="gallery = true"
                            @swiper-main="swiperMain = $event"
                            @swiper-thumbs="swiperThumbs = $event"
                        ></product-main-image>
                    </client-only>
                    <client-only>
                        <v-tooltip location="top" content-class="tooltip-top" open-on-click v-if="product.note">
                            <template v-slot:activator="{ props }">
                                <div v-bind="props"
                                     class="d-inline-flex align-center text-body-1 text-grey ga-2">
                                    <v-icon
                                        :icon="mdiInformationOutline"
                                        color="orange"
                                        style="font-size: inherit"
                                    />
                                    <span class="font-weight-bold">{{ $t('eshop::product-quick-detail.note') }}:</span>
                                    {{ product.note }}
                                </div>
                            </template>
                            <div class="text-body-2 text-black font-weight-bold">
                                {{ $t('eshop::product-quick-detail.note') }}
                            </div>
                            <div class="text-body-2 text-grey">{{ product.note }}</div>
                        </v-tooltip>
                    </client-only>
                    <div v-if="$vuetify.display.lgAndUp && product.annotation" class="mt-2"
                         v-html="product.annotation"></div>
                    <div v-if="product.attributes" class="mt-2">
                        <p v-for="attribute in JSON.parse(product.attributes)" :key="`${product.id}-${attribute.value}`">
                            <b>{{ attribute.name }}</b>: {{ attribute.value }}
                        </p>
                    </div>
                    <category-alert
                        class="mt-6"
                        product-detail
                        product-detail-top
                        :product="{id: product.id, name: product.name}"
                        :selected="categoryAlertSelect"
                        :selected-bike="$page.props.modelSearch?.model"
                    ></category-alert>
                    <storage-block class="mt-6" :product="product" :time="time"></storage-block>
                    <product-detail-basket
                        class="mt-6"
                        :product="product"
                        :to-add="toAdd"
                        :loading="loading"
                        :stock="product.on_stock"
                        @add-to-order="addToOrder(toAdd)"
                        @update:model-value="toAdd = $event; emit('to-add', $event)"
                    ></product-detail-basket>
                    <div id="product-action-btns" class="d-flex flex-wrap justify-space-between ga-5 mt-5 text-body-2">
                        <div>
                            <v-btn class="text-grey to-warning px-0 w-auto h-auto c-product__feature" variant="text"
                                   @click="listModalModel = true">
                                <template v-slot:prepend>
                                    <v-icon :size="16" :icon="mdiContentSaveOutline"></v-icon>
                                </template>
                                <p class="text-body-2 text-decoration-underline">
                                    {{ $t('eshop::product-quick-detail.save_to_a_list') }}</p>
                            </v-btn>
                        </div>
                        <!-- TODO: u25201 -->
                        <div v-if="false">
                            <v-btn class="text-grey to-warning px-0 w-auto h-auto c-product__feature" variant="text">
                                <template v-slot:prepend>
                                    <v-icon :size="16" :icon="mdiBellOutline"></v-icon>
                                </template>
                                <p class="text-body-2 text-decoration-underline">
                                    {{ $t('eshop::product-quick-detail.watchdog') }}</p>
                                <v-dialog
                                    v-model="watchdogModel"
                                    activator="parent"
                                    width="400"
                                >
                                    <product-watchdog-form :id="product.id" @close-dialog="watchdogModel = false">
                                    </product-watchdog-form>
                                </v-dialog>
                            </v-btn>
                        </div>
                        <div>
                            <v-btn class="text-grey to-warning px-0 w-auto h-auto c-product__feature" variant="text">
                                <template v-slot:prepend>
                                    <v-icon :size="16" :icon="mdiMessageTextOutline"></v-icon>
                                </template>
                                <p class="text-body-2 text-decoration-underline">
                                    {{ $t('eshop::product-quick-detail.query') }}</p>
                                <v-dialog
                                    v-model="queryDialog"
                                    activator="parent"
                                    width="600"
                                >
                                    <product-query-form :id="product.id" @close-dialog="queryDialog = false">
                                    </product-query-form>
                                </v-dialog>
                            </v-btn>
                        </div>
                        <div>
                            <v-btn class="text-grey to-warning px-0 w-auto h-auto c-product__feature" variant="text">
                                <template v-slot:prepend>
                                    <v-icon :size="16" :icon="mdiChatQuestionOutline"></v-icon>
                                </template>
                                <p class="text-body-2 text-decoration-underline">
                                    {{ $t('eshop::product-quick-detail.id_buy_but') }}</p>
                                <v-dialog
                                    v-model="likeBuyModel"
                                    activator="parent"
                                    width="600"
                                >
                                    <product-would-buy-form :id="product.id" @close-dialog="likeBuyModel = false">
                                    </product-would-buy-form>
                                </v-dialog>
                            </v-btn>
                        </div>
                    </div>
                    <div class="pt-0">
                        <v-divider class="my-4" />
                        <div v-if="product.all_groups.length" class="d-flex flex-wrap align-center">
                            <span
                                class="mr-2 font-weight-bold">{{ $t('eshop::product-quick-detail.in_categories')
                                }}:</span>
                            <template v-for="(group, index) in product.all_groups" :key="group.id">
                                <Link :href="group.url" class="to-warning text-grey text-decoration-underline">
                                    {{ group.name }}
                                </Link>
                                <template v-if="index !== product.all_groups.length - 1">,&nbsp;</template>
                            </template>
                        </div>
                    </div>
                    <variant-switcher
                        v-if="product.variants.length"
                        :variants="product.variants"
                        :main-product="product.mainProduct"
                        class="mt-8 mb-5"
                        @variant-choosed="chooseVariant"
                    ></variant-switcher>
                </div>
            </v-sheet>
        </v-col>
        <v-dialog v-model="gallery" content-class="align-center" max-width="1200">
            <image-gallery :name="product.name" :images="media" @close="gallery = false"
                           :index="swiperMain.activeIndex" />
        </v-dialog>
        <product-list-modal
            v-model="listModalModel"
            :product="product"
        ></product-list-modal>
    </v-row>
</template>

<script setup>
import {
    computed,
    defineAsyncComponent,
    toRef,
    inject,
    ref,
    watch,
    onMounted,
    onUnmounted,
} from 'vue';
import { useDisplay } from 'vuetify';
import { Link, router, usePage } from '@inertiajs/vue3';
import ImageGallery from './ImageGallery.vue';
import VariantSwitcher from './VariantSwitcher.vue';
import { usePriceStore } from '../stores/price';
import {
    mdiInformationOutline,
    mdiContentSaveOutline,
    mdiBellOutline, mdiMessageTextOutline, mdiChatQuestionOutline, mdiChevronLeft, mdiChevronRight, mdiClose,
} from '@mdi/js';
import { addEvent, generateItem } from '../../../../gtm';
import { collect } from '../../../../analytics';
import { useCartStore } from '../store/cart';
import pinia from '../../../../plugins/pinia';
import MotonetHeader from './MotonetHeader.vue';
import ClientOnly from '../../../../frontend/components/ClientOnly.vue';
import CategoryAlert from './CategoryAlert.vue';
import ProductDetailBasket from './ProductDetailBasket.vue';
import StorageBlock from './StorageBlock.vue';
import ProductListModal from './ProductListModal.vue';
import ProductWouldBuyForm from './ProductWouldBuyForm.vue';
import ProductWatchdogForm from './ProductWatchdogForm.vue';
import ProductMainImage from './ProductMainImage.vue';
import axios from 'axios';
import { getAdditionalVoc, getDiscountBase } from '../../../../utils/saleProcessor.js';

const cartStore = useCartStore(pinia);

const store = usePriceStore(pinia);

const props = defineProps({
    product: Object,
    addValue: Number,
    isModal: {
        type: Boolean,
        default: true,
    },
    compute: {
        type: Boolean,
        default: false,
    },
    navigation: {
        type: Object,
        default: null,
    },
    time: Number,
    allowImageGallery: {
        type: Boolean,
        default: true,
    },
});

const product = toRef(props, 'product');

const productQueryForm = defineAsyncComponent(() => import('./ProductQueryForm.vue'));

const otherImagesCount = computed(() => Object.keys(props.product.other_images).length);

const listModalModel = ref(false);
const watchdogModel = ref(false);
const likeBuyModel = ref(false);

const emit = defineEmits(['selected-variant', 'to-add', 'changeIndex', 'changePage', 'close']);

const showNavigation = computed(() => {
    return !!props.navigation?.meta;
});

const showLeft = computed(() => {
    if (showNavigation.value) {
        const { current_page } = props.navigation.meta;
        const index = props.navigation.index;
        return !(index === 0 && current_page === 1);
    }
});

const showRight = computed(() => {
    if (showNavigation.value) {
        const { current_page, last_page } = props.navigation.meta;
        if (current_page === last_page && !props.navigation.siblings.right) {
            return false;
        }
        return true;
    }
});

const changePage = (left = true) => {
    const { current_page } = props.navigation.meta;
    emit('changePage', left ? current_page - 1 : current_page + 1)
}

const paginate = (left = true) => {
    loadingProduct.value = true;
    let id = product.value.id;
    if (left && props.navigation.siblings.left) {
        id = props.navigation.siblings.left;
    } else if (left) {
        changePage(left)
    }
    if (!left && props.navigation.siblings.right) {
        id = props.navigation.siblings.right;
    } else if (!left) {
        changePage(left)
    }
    emit('changeIndex', id);
};

const media = computed(() => {
    const media = [];
    if (props.product.main_image) {
        media.push(props.product.main_image);
    }
    if (otherImagesCount.value) {
        media.push(...Object.values(props.product.other_images));
    }
    return media;
});
if (props.compute) {
    watch(() => props.product.price, (val => {
        if (!usePage().props.customer.id) {
            return;
        }
        if (val.includes('loading')) {
            const ids = [];
            if (store.prices[props.product.id]) {
                product.value.discount_additional_voc = getAdditionalVoc(store.prices, props.product.id);
                product.value.discount_base = getDiscountBase(store.prices, props.product.id);
                product.value.price = store.prices[props.product.id].nice_price.replace('CZK', 'Kč');
                product.value.price_no_vat = store.prices[props.product.id].nice_price_without_vat.replace('CZK', 'Kč');
            } else {
                ids.push(props.product.id);
            }
            if (ids.length) {
                store.loadPricesFromApi(ids, usePage().props.customer.id).then(prices => {
                    const length = ids.length;
                    for (let i = 0; i < length; i++) {
                        if (prices[props.product.id]) {
                            product.value.discount_additional_voc = getAdditionalVoc(prices, props.product.id);
                            product.value.discount_base = getDiscountBase(prices, props.product.id);
                            product.value.price = prices[props.product.id].nice_price.replace('CZK', 'Kč');
                            product.value.price_no_vat = prices[props.product.id].nice_price_without_vat.replace('CZK', 'Kč');
                        }
                    }
                });
            }
        }
    }), { immediate: true });
}

const swiperThumbs = ref(null);
const swiperMain = ref(null);
const toAdd = ref(props.addValue || 1);
const route = inject('route');

const categoryAlertSelect = computed(() => {
    if (props.product.is_universal === 'Y') {
        return 'universal';
    }
    if ('is_compatible' in props.product) {
        if (usePage().props.modelSearch?.model?.name) {
            return props.product.is_compatible ? 'selected-bike' : 'not-compatible';
        }
    } else {
        if (usePage().props.modelSearch?.model?.name) return 'selected-bike';
    }
    return 'select-bike';
});

const gallery = ref(false);
const queryDialog = ref(false);
const loading = ref(false);
const loadingProduct = ref(false);

watch(gallery, (val) => {
    if (val) {
        document.getElementById('root').classList.add('gallery-open');
    } else {
        document.getElementById('root').classList.remove('gallery-open');
    }
});

const addToOrder = (count = 1) => {
    loading.value = true;
    // eslint-disable-next-line no-undef
    axios.post(route('order.addProduct'), { id_product: props.product.id, count }).then((resp) => {
        usePage().props.flash = resp.data.flash;
        loading.value = false;
        if ('order' in resp.data) {
            usePage().props.order = resp.data.order;
            usePage().props.addToCart = {
                toBuy: resp.data.toBuy,
                order: resp.data.order,
            };
            const item = cartStore.cartItems.find((item) => {
                return item.id_products == props.product.id;
            });
            if (item) {
                const price = parseFloat(item.nice_price.replace(/\s/g, '').replace(/,/g, '.'));
                const attributes = {
                    quantity: count,
                    price: price.toFixed(2),
                };
                addEvent({
                    event: 'add_to_cart',
                    ecommerce: {
                        currency: usePage().props.currency,
                        value: (price * count).toFixed(2),
                        items: generateItem(props.product, attributes),
                    },
                });
            }
        }
    });
};

const chooseVariant = (variant) => {
    router.visit(variant.url);
};

if (typeof window !== 'undefined') {
    collect(props.product.id, 'products', props.isModal ? 'quick-detail' : 'detail', useDisplay().platform.value);
    const gtmItem = {
        item_id: props.product.id,
        item_name: props.product.name,
        price: parseFloat(props.product.price.replace(/\s/g, '').replace(/,/g, '.')).toFixed(2),
        quantity: 1,
    };
    if (props.product.manufacturer) {
        gtmItem['item_brand'] = props.product.manufacturer.name;
    }
    if (props.product.all_groups.length) {
        for (let i = 0; i < props.product.all_groups.length; i++) {
            if (i > 5) break;
            gtmItem[`item_category${i !== 0 ? i : ''}`] = props.product.all_groups[i].name;
        }
    }
    addEvent({
        event: 'view_item', ecommerce: {
            currency: usePage().props.currency,
            value: gtmItem.price,
            items: [
                gtmItem,
            ],
        },
    });
}

const arrowNavigation = (event) => {
    if (event.keyCode) {
        switch (event.keyCode) {
            case 37:
                if (showLeft.value) {
                    paginate(true);
                }
                break;
            case 39:
                if (showRight.value) {
                    paginate(false);
                }
                break;
        }
    }
}

if (!import.meta.env.SSR && showNavigation.value) {
    onMounted(() => {
        window.addEventListener('keydown', arrowNavigation, null);
    });

    onUnmounted(() => {
        window.removeEventListener('keydown', arrowNavigation);
    });
}
</script>

<style lang="scss">
.plus-minus {
    &.v-btn--disabled {
        box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
    }
}
</style>

<style scoped lang="scss">
@use '../../../../plugins/vuetify-settings' as *;
@use 'vuetify/lib/styles/settings/variables' as *;
@use 'sass:map';

.plus-minus {
    min-width: 48px;
}

.variant-buttons {
    ::v-deep(.v-expansion-panel-text__wrapper) {
        padding: 16px 0 0;
    }
}

.cart-btn {
    min-height: 48px;
}

:deep(.c-product__feature) {
    .v-btn__prepend {
        margin-inline: 0 $spacer;
    }
}

#product-action-btns {
    @media #{map.get($display-breakpoints, 'sm-and-down')} {
        > * {
            flex: 0 1 calc(50% - ($spacer * 4));
        }
    }
}
</style>
